module.exports = __webpack_public_path__ + "img/home-tk.8a5af440.svg";